import { render } from "./TSDView.vue?vue&type=template&id=713a557d"
import script from "./TSDView.vue?vue&type=script&lang=js"
export * from "./TSDView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__